import * as React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

const InjectMassage: React.ComponentType<React.PropsWithChildren<any>> = (props) => <FormattedMessage tagName="span" {...props} />;
export const IntlMessage = injectIntl(InjectMassage);
